<template>
    <div class="myoutcomes col-md-12" style="margin-bottom: 100px;">
         <b-container style="margin-bottom: 50px;">
        <b-container>
        <div class="row" >
             <div class="col-md-12 align-items-center d-flex justify-content-left" style="text-align:left; background-color:#6C6C6C;">
                <p class="mt-3 align-items-center d-flex justify-content-center" style="color:#FFFFFF; font-size:22px; font-weight:600;">My Reports</p>
            </div>
        </div>
        </b-container>
        <b-container>
        <div class="row align-items-center d-flex justify-content-center" style="margin-top:20px;">
                    <div class="col-md-4 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3">
                            <b-row class="">
                            <b-col sm="3" style="text-align:right;" class="mt-1">  
                            <label style="font-weight:600; font-size:14px;">Show</label><br>
                            </b-col>
                            <b-col sm="4" class="align-items-center d-flex justify-content-left">
                            <b-form-select
                                    style="font-weight:600; font-size:14px; border:none; border-radius: unset;"
                                    class=" col-xl-7 ml-1"
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions">
                            </b-form-select>
                            </b-col>
                            <b-col sm="5">
                            </b-col>
                            </b-row>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3">
                            <b-row class="">
                            <b-col sm="5" style="text-align:right" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Filter By</label><br>
                            </b-col>
                            <b-col sm="7" class="align-items-center d-flex justify-content-left" style="text-align:left;">
                            <b-form-select style="font-weight:600; font-size:14px; border:none; border-radius: unset;" v-model="filterBy" id="filterBySelect" :options="sortOptions" class=" col-xl-12"></b-form-select>
                            </b-col>
                            </b-row>
                        </b-form-group>
                    </div>
                     <div class="col-md-1 align-items-center d-flex justify-content-center" style="text-align:right; color:#565754; font-size:14px;">
                        <b-button class="mt-3" size="sm" @click="filterOutcomes" variant="outline-none" style="font-weight:600; font-size:18px;"><b-icon-search class="h1"></b-icon-search></b-button>
                    </div>
                    <div class="col-md-3 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3" style="text-align:left">
                            <b-form-input
                                    style="font-weight:600; font-size:14px; border-radius: unset; border:none;"
                                    v-on:keyup.enter="filterOutcomes"
                                    v-model="filterValue"
                                    type="search"
                                    id="filterInput"
                                    size="sm"
                                    class=""
                                    placeholder="Search by column selected"></b-form-input>
                        </b-form-group>
                    </div>
            </div>
        </b-container>
        <b-container>
        <div class="row" style="margin-top:18px;">
            <b-table class="myTable" hover="" bordered="" style="background-color:#F4F4F4;" show-empty stacked="md" :items="fetchData" :fields="fields"  ref="tableOutcomes"
                     :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection" :small="small" :per-page="perPage"
                     :filter="filter"
                     :filterIncludedFields="filterOn"
                     :current-page="currentPage">

                <template v-slot:cell(success)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.success"/>
                        </template>

                        <template v-slot:cell(outcome.outcome_name)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.outcome.outcome_name"/>
                        </template>

                        <template v-slot:cell(outcome.assembly_id)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.outcome.assembly_id"/>
                        </template>

                        <template v-slot:cell(period.period)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.period.period"/>
                        </template>

                        <template v-slot:cell(outcome.outcome_code)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.outcome.outcome_code"/>
                        </template>

                        <template v-slot:cell(partners)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.partners"/>
                        </template>

                         <template v-slot:cell(type)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-if="data.item.type==0">Member States Report</span>
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-else>Secretariat Report</span>
                        </template>

                        <template v-slot:cell(actions)="row">
                            <router-link size="sm" :to="{name: 'viewmyreport', params:{id: row.item.id}}" variant="primary"
                                      class="mr-1 mt-1 mb-1" style="font-family:roboto; font-size:17px; font-weight:500;">
                                <b-icon-eye></b-icon-eye>
                                View
                            </router-link><br><br>
                            <!--<router-link size="sm" :to="{name: 'viewmyreport', params:{id: row.item.id}}" variant="danger"
                                      class="mr-1 mt-1 mb-1" style="color:black; font-family:roboto; font-size:17px; font-weight:500;">
                                <b-icon-trash variant="danger"></b-icon-trash> Delete
                            </router-link>-->
                        </template>
            </b-table>
        </div>
        </b-container>
        <b-container>

        <div v-bind:hidden="loadedData" id="loadingGif" style="text-align: center;">
            <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
        </div>
        </b-container>
        <b-container class="mb-4" style="margin-bottom:50px;">

        <div class="col-md-12 mt-3">
            <div class="row justify-content-center">
                <b-pagination style="color:#565754" size="md" :total-rows="totalItems" v-model="currentPage" :per-page="perPage">
                </b-pagination>
            </div>
        </div>
        </b-container>
         </b-container>
    </div>
</template>
<script>
    /* eslint-disable no-console */
    // import Addoutcome from '@/components/Addoutcome.vue'
    export default {
        name: 'OutcomesMs',
        components: {
        },
        data() {
            return {
                apiUrl: process.env.VUE_APP_API_PATH,
                items: [],
                loadedData: false,
                filter: null,
                filterValue: '',
                filterOn: [],
                issecretariat: false,
                isEditing: false,
                small: false,
                sortBy: '',
                filterBy: 'outcome.outcome_name',
                sortDesc: false,
                sortDirection: 'asc',
                pageOptions: [5, 10, 15],
                fields: [
                     {
                        key: 'outcome.assembly_id',
                        label: 'ASSEMBLY CODE',
                        searchable: true,
                        //sortable: true,
                    },
                    {
                        key: 'outcome.outcome_code',
                        label: 'OUTCOME CODE',
                        searchable: true,
                        //sortable: true,
                    },
                    {
                        key: 'outcome.outcome_name',
                        label: 'OUTCOME NAME',
                        searchable: true,
                        //sortable: true,
                    },
                    {
                        key: 'period.period',
                        label: 'REPORTING PERIOD',
                        //sortable: true,
                        searchable: true,
                    },
                    {
                        key: 'actions',
                        label: 'ACTIONS',
                        thStyle: {width: '100px'},
                    }
                     
                ],
                currentPage: 1,
                perPage: 10,
                totalItems: 0,
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
                item: {
                    id: '',
                    title: '',
                    outcome_type: '',
                    outcome_summary: ''
                }
            }
        },
        created() {
            if(this.$route.query.filterValue) {
                this.filterValue = this.$route.query.filterValue;
                this.filterBy = this.$route.query.filterBy;
            }
        },
        computed: {
            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.searchable)
                    .map(f => {
                        return {text: f.label, value: f.key}
                    })
            },
            getShowEditDelete(){
                let isadmin = document.getElementById('loggedInUserIsAdmin').value;
                if(isadmin != '1'){
                    return true;
                }

                return false;
            },
            computedFields() {
                // If the user isn't secretariat, filter out reporters field.
                let loggedInUniteId = document.getElementById('loggedInUniteId');
                if (loggedInUniteId != null && loggedInUniteId.value == '0') {
                    return true;
                }
                if(this.issecretariat){
                    return this.fields.filter(field => !field.issecretariat);
                }   
                // If the user IS an admin, return all fields.
                else
                    return this.fields;
             },
        },
        methods: {
            expandValues(){
              return "TODO";
            },
            info(item, index, button) {
                this.infoModal.title = item.outcome_type_model.outcome_type + '\n' + item.outcome_code + ':' + '\n' + item.outcome_name
                this.infoModal.code = item.outcome_code
                this.infoModal.summary = item.outcome_summary
                this.infoModal.actions_required = item.actions_required
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            editTodo(item) {
                this.isEditing = true;
                this.this.item.id = item.id;
                this.item.outcome_type = item.outcome_type;
                this.item.outcome_summary = item.outcome_summary;
            },
            dataPass(item) {
                this.code = item.outcome_code
            },
            resetInfoModal() {
                this.infoModal.title = ''
                this.infoModal.content = ''
            },
            filterOutcomes() {
                this.loadedData = false;
                this.currentPage = 1
                this.$refs.tableOutcomes.refresh();
            },
             getLoggedInUserId() {
                let loggedInUserId = document.getElementById('loggedInUserId');
                return loggedInUserId == null ? 'guest' : loggedInUserId.value;
            },
            getLoggedInUserName() {
                let loggedInUserName = document.getElementById('loggedInUserName');
                return loggedInUserName == null ? '' : loggedInUserName.value;
            },
            getLoggedInUserEmail() {
                let loggedInUserEmail = document.getElementById('loggedInUserEmail');
                return loggedInUserEmail == null ? '' : loggedInUserEmail.value;
            },
            fetchData(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDesc ? 'desc' : 'asc';
                fetch(url + '/getmyreports?_page=' + `${this.currentPage}&_limit=${this.perPage}&_filterBy=${this.filterBy}&_sortDirection=${sortD}&_filter=${this.filterValue}` + "&loggedInUserId=" + this.getLoggedInUserId() + "&loggedInUserName=" + this.getLoggedInUserName() + "&loggedInUserEmail=" + this.getLoggedInUserEmail())
                    .then(res => res.json())
                    .then(res => {
                        this.loadedData = true;
                        this.totalItems = res["totalItems"]

                        callback(res["data"])
                    })
                return null
            }
        }
    }
</script>

<style href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet"></style>

<style>
@import url(https://fonts.googleapis.com/css?family=Roboto);
.myTable thead {
   background-color: #00A5E5;
   color: #FFFFFF;
   font-size: 22px!important;
   font-weight: 300!important;
}
.table-bordered th, .table-bordered td {
    border: 1px solid white;
}
.myoutcomes{
    margin: auto!important;
}
.page-link {
    position: relative;
    display:grid;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #171717!important;
    background-color:#F4F4F4!important;
    border: 5px solid white!important;
}
.page-item.disabled .page-link {
    color: #6c757d!important;
    pointer-events: none;
    cursor: auto;
    background-color:#F4F4F4!important;
    border-color: white!important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #0062FF!important;
    background-color: #82CAFA!important;
    border-color: white!important;
}
.btn-block {
    display:inline-block;
    width: 100%!important;
    height:56px;
}
</style>